import React from 'react';
import Card from '@lightspeed/cirrus-card';

const baseClass = 'retail-listing';

export const Listing = ({ children, className, ...rest }) => (
  <div className={className} {...rest}>
    <Card>
      <table className={baseClass}>
        <tbody>{children}</tbody>
      </table>
    </Card>
  </div>
);

export const ListingRow = ({ children }) => <tr className={`${baseClass}__row`}>{children}</tr>;
